import { OPTIMIZELY } from 'pages/MyAccount/services/actions/optimizelyActions';

export const optimizelyInitialState = [];

export function optimizelyReducer(state = optimizelyInitialState, action) {
  switch (action.type) {
    case OPTIMIZELY.SET_OPTIMIZELY_SETTING: {
      return [...state, ...action.payload];
    }

    default: {
      return state;
    }
  }
}

export default optimizelyReducer;
